/**
 * @generated SignedSource<<5d27bdb8a01afbb48dc0c873d636499f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type WorkatoIntegration = "HiBob" | "%future added value";
export type ActivateWorkatoIntegrationInput = {
  integration?: WorkatoIntegration | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type activateWorkatoIntegrationMutation$variables = {
  input: ActivateWorkatoIntegrationInput;
};
export type activateWorkatoIntegrationMutation$data = {
  readonly activateWorkatoIntegration: {
    readonly outcome: string | null;
    readonly company: {
      readonly id: string;
      readonly workatoCustomerId: string | null;
      readonly workatoIframeToken: string | null;
      readonly hiBobEnabled: boolean | null;
      readonly workatoForecastHiBobConnectionId: string | null;
      readonly workatoHiBobConnectionId: string | null;
      readonly sageIntacctEnabled: boolean | null;
      readonly workatoForecastSageIntacctConnectionId: string | null;
      readonly workatoSageIntacctConnectionId: string | null;
    } | null;
  } | null;
};
export type activateWorkatoIntegrationMutation = {
  variables: activateWorkatoIntegrationMutation$variables;
  response: activateWorkatoIntegrationMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ActivateWorkatoIntegrationPayload",
    "kind": "LinkedField",
    "name": "activateWorkatoIntegration",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "outcome",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Company",
        "kind": "LinkedField",
        "name": "company",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "workatoCustomerId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "workatoIframeToken",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hiBobEnabled",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "workatoForecastHiBobConnectionId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "workatoHiBobConnectionId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "sageIntacctEnabled",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "workatoForecastSageIntacctConnectionId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "workatoSageIntacctConnectionId",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "activateWorkatoIntegrationMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "activateWorkatoIntegrationMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "ccb6fce39fa2e5cea04bd744e7ae796c",
    "id": null,
    "metadata": {},
    "name": "activateWorkatoIntegrationMutation",
    "operationKind": "mutation",
    "text": "mutation activateWorkatoIntegrationMutation(\n  $input: ActivateWorkatoIntegrationInput!\n) {\n  activateWorkatoIntegration(input: $input) {\n    outcome\n    company {\n      id\n      workatoCustomerId\n      workatoIframeToken\n      hiBobEnabled\n      workatoForecastHiBobConnectionId\n      workatoHiBobConnectionId\n      sageIntacctEnabled\n      workatoForecastSageIntacctConnectionId\n      workatoSageIntacctConnectionId\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "b12a1eef38706fbde344df9984986c35";

export default node;
